// DataPainterWidget/index.jsx
// Module-load registration — same pattern as commandEngine.registerXxxCommand.
import painterRegistry from './Core/PainterRegistry';
import cardPainterManager from './Core/CardPainterManager';
import CryptoTickerWidget from './CryptoTickerWidget/CryptoTickerWidget';
import FearGreedWidget from './FearGreedWidget/FearGreedWidget';
import CmcUsageWidget from './CmcUsageWidget/CmcUsageWidget';

painterRegistry.register('simpleTickers:v1', CryptoTickerWidget);
painterRegistry.register('fearGreed:v1', FearGreedWidget);
painterRegistry.register('cmcUsage:v1', CmcUsageWidget);

export default cardPainterManager;
